import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: SarinManS
 * id 842FCAE6-0FE2-495D-980C-1ABA85257C77
 * name chevron-left-circle
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chevron-left-circle.svg
 * tags
 * - Arrow 
 */
export const ChevronLeftCircleIcon = createSvgIcon(<><path d="M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M15.4,16.6L10.8,12L15.4,7.4L14,6L8,12L14,18L15.4,16.6Z" /></>, 'ChevronLeftCircleIcon');
export default ChevronLeftCircleIcon